import { useLocation } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setHeaderMenuData } from './headerMenuActions';
import { NavigationItemType } from 'framework/navigation';

interface HeaderMenuState {
  menuData?: NavigationItemType[];
  pathname?: string;
}

const useHeaderMenuService = () => {
  const dispatch = useDispatch();
  const menuContainer = useSelector((state: { headerMenu: HeaderMenuState[] }) => state.headerMenu, shallowEqual);
  const { pathname } = useLocation();

  const addMenuData = (menuData: NavigationItemType[]) => {
    dispatch(setHeaderMenuData(menuData, pathname));
  };

  const getMenuData = (): NavigationItemType[] => {
    const data = menuContainer?.filter(m => m?.pathname === pathname) || [];

    return data[0]?.menuData || [];
  };

  return {
    addMenuData,
    getMenuData,
  };
};

export default useHeaderMenuService;
